export default {
  header: 'Comenzi noi suspendate',
  text: 'Apasă oriunde pentru a relua',
};
